const morning = ['IMG_0109.JPG',
'IMG_0110.JPG',
'IMG_0111.JPG',
'IMG_0258.JPG',
'IMG_0903.JPG',
'IMG_0904.JPG',
'IMG_0905.JPG',
'IMG_0908.JPG',
'IMG_0960.JPG',
'IMG_0963.JPG',
'IMG_0965.JPG',
'IMG_1070.JPG',
'IMG_1518.JPG',
'IMG_1769.JPG',
'IMG_1865.JPG',
'IMG_2503.JPG',
'IMG_2504.JPG',
'IMG_2822.JPG',
'IMG_2824.JPG',
'IMG_3050.JPG',
'IMG_3408.JPG',
'IMG_3409.JPG',
'IMG_3579.JPG',
'IMG_3608.JPG',
'IMG_3749.JPG',
'RebelXS_IMG_0375.JPG',
'RebelXS_IMG_0674.JPG',
'RebelXS_IMG_3196.JPG',
'RebelXS_IMG_3452.JPG',
'iPhone2G_IMG_0274.JPG',
'iPhone2G_IMG_0275.JPG'];

export default morning;